import React from 'react';
import Colors from "../components/Colors";
import Gallery from '../components/Gallery';

function WorkSingle({workObj}) {
    return (
        <main className="work-single page">
            <section className="single-intro section-wrapper intro">
                <p className="small-section-title">{workObj.type}</p>
                <h1>{workObj.title}</h1>
                
                <img src={workObj.thumbnail} alt={workObj.title + " Mockup"} />
            </section>

            {'links' in workObj && <section className="work-links section-wrapper">
                {'liveSite' in workObj.links && <a href={workObj.links.liveSite} className="btn"  target="_blank" rel="noopener noreferrer">Live Site</a>}
                {'gitHub' in workObj.links && <a href={workObj.links.gitHub} className="btn" target="_blank" rel="noopener noreferrer">GitHub</a>}
            </section>}
            

            <section className="work-overview section-wrapper">
                <h2 className="small-section-title">Overview</h2>
                <p>{workObj.overview}</p>
            </section>

            <section className="work-skills section-wrapper">
                <h2 className="small-section-title">Development Stack</h2>
                
                <ul className="skill-list">
                    {workObj.skills.map((skill, i) => {
                        return <li key={i}>{skill}</li>
                    })}
                </ul>
            </section>

            {'team' in workObj && <section className="work-team section-wrapper">
                <h2 className="small-section-title">Development Team</h2>
                
                <ul>
                {workObj.team.map((member, j) => {
                    return <li key={j}>{member}</li>
                    })}
                </ul>
            </section>}

            {'finalProduct' in workObj && <section className="work-final section-wrapper">
                <h2 className="small-section-title">{workObj.finalProduct.heading}</h2>

                

                {workObj.finalProduct.images.map((image, j) => {
                    return <div key={j} className="image-containter">
                        <img src={image} alt="Final Product" />
                        
                    </div>
                    })}
                
                <h3 className="product-line">{workObj.finalProduct.text}</h3>
                
            </section>}

            <section className="work-details section-wrapper">
                <h2 className="small-section-title">Details</h2>
                
                {workObj.contents.map((content, i) => {
                    
                    return <div className="work-detail-section" key={i}>
                        {'section' in content && <h3 className="detail-title">{content.section}</h3>}

                        {'text' in content && <p>{content.text}</p>}

                        {'colors' in content && <Colors colors={content.colors}/>}

                        {'images' in content && <Gallery images={content.images}/>}
                        </div>
                    })}
                
            </section>
        </main>
    )
}

export default WorkSingle
